/* mv-table-cards – adds data-label to cells of comparison tables (3+ columns) so they can be shown as cards on phones (CSS in mv-table-cards.css). Montivive, 19 Oct 2026. */
(function () {
  function run() {
    var tables = document.querySelectorAll('main table');
    Array.prototype.forEach.call(tables, function (t) {
      if (t.classList.contains('mv-tc') || t.closest('form, .cart-items, [data-mv-tc-off]')) return;
      var head = t.tHead && t.tHead.rows[0], headRow = null;
      if (!head) {
        var r0 = t.rows[0];
        if (r0 && r0.cells.length && Array.prototype.every.call(r0.cells, function (c) { return c.tagName === 'TH'; })) { head = r0; headRow = r0; }
      }
      if (!head) return;
      var labels = [];
      Array.prototype.forEach.call(head.cells, function (c) {
        var span = c.colSpan || 1, txt = c.textContent.replace(/\s+/g, ' ').trim();
        for (var k = 0; k < span; k++) labels.push(txt);
      });
      if (labels.length < 3) return;
      Array.prototype.forEach.call(t.rows, function (r) {
        if (r === head || (t.tHead && r.parentNode === t.tHead)) return;
        var i = 0;
        Array.prototype.forEach.call(r.cells, function (c) {
          if (labels[i] && !c.hasAttribute('data-label')) c.setAttribute('data-label', labels[i]);
          i += c.colSpan || 1;
        });
      });
      if (headRow) headRow.classList.add('mv-tc-head');
      t.classList.add('mv-tc');
    });
  }
  if (document.readyState !== 'loading') run(); else document.addEventListener('DOMContentLoaded', run);
})();
